import {parseFeeTag} from '@/screens/Merchants/Fee/updateFeeReducer';
import type {
  AfriexCurrencyCode,
  AfriexPromoTags,
  AfriexRatePromo,
} from '@/types';

export const extractCurrenciesFromTags = (
  tier: AfriexRatePromo,
): AfriexCurrencyCode[] => {
  const rateCurrencies = [
    tier?.meta?.tags?.TO_CURRENCY,
    tier?.meta?.tags?.FROM_CURRENCY,
  ]
    .filter(Boolean)
    ?.flatMap((c) => c?.split('::')?.[1]?.split(',')) as AfriexCurrencyCode[];
  return rateCurrencies ?? [];
};

export const convertFeeTagToPromoTags = (tag: string): AfriexPromoTags => {
  const {field: f, operator, value} = parseFeeTag(tag) ?? {};
  return f && operator && value
    ? {
        [f]: `${operator}::${value}`,
      }
    : {};
};

export const convertPromoTagsToBusinessFeeTags = (
  tags: AfriexPromoTags,
): string[] => {
  return Object.entries(tags || {}).map(([k, v]) => {
    const [operator, value] = v.split('::');
    return `${k}_${operator}_${value}`;
  });
};
